import * as React from "react";

import { asString } from "common/components/component-helpers";
import { LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { lazilyLoadedComponent } from "lib/react-lazy-loading";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { ErrorBoundary } from "lib/error-boundary";

const YouTubePlayer = lazilyLoadedComponent("youtube-player", () => import("../../ui/deprecated/youtube-player"));

export const YouTubeMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[videoID]] = useForceValueProducers(getValueProducers, force, ctx);
    if (videoID === undefined) return null;
    if (videoID === LOADING) return env.renderProgress();
    return (
        <ErrorBoundary>
            <React.Suspense fallback={() => env.renderProgress()}>
                <YouTubePlayer id={asString(videoID)} />
            </React.Suspense>
        </ErrorBoundary>
    );
};
